module.exports = __webpack_public_path__ + "static/media/8.7d52de24.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/8.png
// module id = 717
// module chunks = 0